<template>
  <div v-if="isVisible" class="fixed-nav">
    <v-app-bar color="#E7D4B8" style="box-shadow: none">
      <v-container fluid class="d-flex align-center justify-center">
        <v-row>
          <v-col cols="2">
            <img
              src="@/assets/logo.png"
              @click="$router.push({ name: 'home' })"
              style="cursor: pointer; width: 40%"
              alt="Logo"
            />
          </v-col>
          <v-col cols="8">
            <div class="navlist d-flex justify-center" dir="rtl">
              <span class="nav-link" v-for="cat in categories" :key="cat.title">
                <router-link
                  :to="{
                    name: 'products_category',
                    query: { category: cat.route, title: cat.title },
                  }"
                  style="color: #333333; text-decoration: none"
                  >{{ cat.title }}</router-link
                >
              </span>
            </div>
          </v-col>
          <v-col
            cols="2"
            class="d-flex justify-end align-center"
            style="gap: 10px"
          >
            <v-btn icon variant="text" @click="openCart" aria-label="Cart">
              <v-badge
                :content="itemsCount"
                :model-value="itemsCount > 0"
                color="red"
              >
                <v-icon size="28">mdi-cart-outline</v-icon>
              </v-badge>
            </v-btn>
            <v-btn
              text
              class="action-link"
              @click="
                $router.push({
                  name: 'contact_us',
                })
              "
              >للتواصل معنا</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
import { useProductsModule } from "@/stores/products";
import { useCartModule } from "@/stores/cart";
import { mapState } from "pinia";
export default {
  inject: ["Emitter"],
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapState(useProductsModule, ["categories"]),
    ...mapState(useCartModule, ["itemsCount"]),
  },
  beforeUnmount() {
    // Updated this line
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    openCart() {
      this.$root?.Emitter?.emit?.("openCart");
      if (this.Emitter) this.Emitter.emit("openCart");
    },
    handleScroll() {
      this.isVisible = window.scrollY >= 126;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.google.com/noto/specimen/Noto+Kufi+Arabic?lang=ar_Arab");
.fixed-nav {
  position: fixed; /* Keep it fixed */
  top: 0; /* Position it below the AppNav */
  left: 0;
  width: 100%;
  z-index: 2000; /* Higher z-index to appear above AppNav */
}
.action-link {
  font-family: "Noto Kufi Arabic", sans-serif;
  font-weight: bold;
}
.navlist {
  display: flex;
  gap: 20px;
  height: 100%; /* Adds space between each nav item */
}

.nav-link {
  font-family: "Noto Kufi Arabic", sans-serif;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  text-transform: uppercase;
  position: relative;
  margin-top: 15px;
  margin-bottom: 0%;
  cursor: pointer; /* Shows pointer on hover */
}

.nav-link::after {
  content: "";
  position: absolute;
  bottom: -5px; /* Adjust this value to position the underline correctly */
  left: 0;
  width: 0;
  height: 2px;
  background-color: #916811;
  transition: width 0.3s ease-in-out, bottom 0.3s ease-in-out;
}

.nav-link:hover::after,
.nav-link:focus::after {
  width: 100%;
  bottom: 0; /* Ensure the underline is at the bottom of the link */
}
/* Rest of your styles */
</style>
